import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from '@gympass/yoga'

import { hrPortal } from '@assets'

import Container from '../../Home.style'
import * as Style from './HowItWorksCompanies.style'

import useHowItWorks from './state'

export default function HowItWorks() {
  const { howItWorksForEmployees } = useHowItWorks()

  return (
    <Style.Wrapper>
      <Container>
        <Row>
          <Col xxs={12} xl-start={2} xl={6}>
            <Style.Title>
              <FormattedMessage
                id="smb_acquisition_home.how_it_works.benefits.company.title"
                values={{
                  span: (...chunks) => <span>{chunks}</span>,
                }}
              />
            </Style.Title>
          </Col>
        </Row>

        <Style.ListWrapper>
          <Row>
            <Col xxs={12} xl-start={2} xl={6}>
              {howItWorksForEmployees.map(item => (
                <Style.Item key={item.id}>
                  <Style.ItemIcon>
                    <Style.ItemIconText>{item.id}</Style.ItemIconText>
                  </Style.ItemIcon>

                  <Style.ItemDescription>
                    <Style.ItemTitle>{item.title}</Style.ItemTitle>
                    <Style.ItemSubtitle>{item.description}</Style.ItemSubtitle>
                  </Style.ItemDescription>
                </Style.Item>
              ))}
            </Col>

            <Col xl={5} hide={['xxs', 'xs', 'sm', 'md', 'lg']}>
              <Style.Figure>
                <Style.Image
                  src={hrPortal}
                  alt="A woman seeing the Gympass HR portal"
                />
                <Style.FigureCaption>
                  <Style.ImageDescription>
                    <FormattedMessage id="smb_acquisition_home.how_it_works.benefits.employee.illustration.description" />
                  </Style.ImageDescription>
                </Style.FigureCaption>
              </Style.Figure>
            </Col>
          </Row>
        </Style.ListWrapper>
      </Container>
    </Style.Wrapper>
  )
}
